<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <v-form v-model="valid" style="width:100%" ref="userForm" @submit="save" onSubmit="return false">
            <v-container fluid>
                <v-layout row wrap>
                    <v-flex md3>
                        <v-text-field label="E-Mail (User Name)"
                                      v-model="user.email"
                                      ref="userEmail"
                                      :rules="serverValidation('email','E-Mail')"
                                      counter="100"></v-text-field>
                    </v-flex>
                </v-layout>
                <v-layout row wrap>
                    <v-flex md3>
                        <v-text-field counter="100" label="First Name" v-model="user.firstName" :rules="serverValidation('firstName','First Name')"></v-text-field>
                    </v-flex>
                    <v-flex md3>
                        <v-text-field counter="100" label="Middle Name" v-model="user.middleName"></v-text-field>
                    </v-flex>
                    <v-flex md3>
                        <v-text-field counter="100" label="Last Name" v-model="user.lastName" :rules="serverValidation('lastName','Last Name')"></v-text-field>
                    </v-flex>
                </v-layout>

                <v-layout row wrap>
                    <v-flex md3>
                        <v-text-field counter="100" label="Alias" v-model="user.alias"></v-text-field>
                    </v-flex>
                    <v-flex md3>
                        <v-text-field label="Phone Number" v-model="user.phoneNumber"
                                      v-mask="'(###) ### - ####'"></v-text-field>
                    </v-flex>
                    <v-flex md3 v-if="$permissionHolder.hasPermission('GLOBAL_ADMIN')">
                        <v-tooltip v-model="globalAdminTooltip" bottom>
                            <template v-slot:activator="{ on }">
                                <v-checkbox label="Global Admin"
                                            v-on="on"
                                            v-model="user.globalAdmin"
                                ></v-checkbox>
                            </template>
                            <span>Grants User Access to All Organizations. Use only for CPS Employees</span>
                        </v-tooltip>
                    </v-flex>
                </v-layout>
                <v-layout row wrap>
                    <v-flex md3>
                        <v-select :items="organizations"
                                  label="Organization"
                                  item-text="name"
                                  :rules="serverValidation('organizationId','Organization')"
                                  v-model="user.organizationId"
                                  item-value="id"></v-select>
                    </v-flex>
                </v-layout>
                <v-radio-group v-model="authenticationOption">
                    <template v-slot:label>
                        Authentication
                    </template>
                    <v-radio label="Generate a Password" value="G"></v-radio>
                    <v-radio label="Specify Password" value="C"></v-radio>
                </v-radio-group>
                <v-layout row wrap>
                    <v-flex md12>
                        <v-alert outlined  type="info" :value="true">
                            Note: User Will be Required to Change Password On Login.
                        </v-alert>
                    </v-flex>
                </v-layout>
                <v-layout row wrap v-if="authenticationOption == 'G'">
                    <v-flex md12>
                        <v-alert outlined  type="info" :value="true">
                            A Password Will Be Sent to The Specified E-Mail Address. Please Ensure It is Valid.
                        </v-alert>
                    </v-flex>
                </v-layout>

                <v-layout row wrap v-if="authenticationOption == 'C'">
                    <v-flex md3>
                        <v-text-field label="Password"
                                      type="password"
                                      :rules="serverValidation('password','Password')"
                                      v-model="user.password"></v-text-field>
                    </v-flex>
                    <v-flex md3>
                        <v-text-field label="Confirm Password" type="password"
                                      v-model="user.confirmPassword"></v-text-field>
                    </v-flex>
                </v-layout>

                <v-layout row wrap>
                    <v-btn type="button"
                           outlined
                           class="mx-2"
                           @click="goBack()"
                           color="warning"
                           :disabled="overlay"
                           :loading="overlay">Go Back</v-btn>
                    <v-btn type="submit"
                           outlined
                           class="mx-2"
                           color="success"
                           :disabled="overlay"
                           :loading="overlay">Save</v-btn>
                    <v-progress-circular
                            :width="3"
                            v-show="overlay"
                            color="red"
                            indeterminate="">
                    </v-progress-circular>
                </v-layout>
            </v-container>
        </v-form>
    </div>
</template>

<script>
    import api from '@/api';
    import {validationMixin} from '@/mixins/validations'
    export default {
        name:'CreateUser',
        mixins:[validationMixin],
        data() {
            return {
                user: {},
                organizations: [],
                valid: true,
                overlay: false,
                authenticationOption : 'C',
                globalAdminTooltip : false
            }
        },
        created() {
            api.organization.search().then(orgs => {
                this.organizations = orgs.list;
                this.$refs.userEmail.focus();
            });
        },
        methods: {
            save() {
                this.$refs.userForm.resetValidation();

                if (this.authenticationOption == 'C') {
                    const p = this.user.password || '';
                    const cp = this.user.confirmPassword || '';
                    if (p != cp) {
                        this.$root.$emit('globalError', 'Passwords Must Match');
                        return;
                    }
                }

                this.overlay = true;
                this.user.generatePassword = this.authenticationOption == 'G';
                this.doSave().then((userId) => {
                    this.$router.replace('/user/'+userId);
                });
            },
            doSave() {

                const that = this;
                return new Promise((resolve,reject) => {
                    api.user.post(that.user).then((userData) => {
                        resolve(userData.id);
                    }).catch((error) => {
                        if (this.processErrors(error) == this.RESPONSE_VALIDATION) {
                            this.$refs.userForm.validate();
                        }
                    }).finally(that.overlay = false);
                });
            },
            goBack() {
                this.$router.go(-1);
            }
        }
    }
</script>